import React, { useState } from 'react'
import type { GestureResponderEvent } from 'react-native'

import { Icon } from '~/components/icon'
import type { IInputProps, componentType } from '../../types'

import * as S from './index.styles'

export function Input(props: IInputProps) {
  const {
    readOnly = false,
    size = 'sm',
    onLongPress,
    onPressOut,
    onPressIn,
    disabled,
    children,
    hiddenClearButton = false,
  } = props

  const defaultProps = {
    readOnly,
    size,
    disabled: disabled!,
    type: 'input' as componentType,
  }

  const [isPressed, setIsPressed] = useState(false)

  const iconColor = disabled
    ? 'colorTextNeutralDisabled'
    : readOnly
      ? 'colorTextNeutralReadonly'
      : 'colorTextDangerAlternative'

  function handlePressIn(event: GestureResponderEvent) {
    setIsPressed(true)
    onPressIn?.(event)
  }

  function handlePressOut(event: GestureResponderEvent) {
    setIsPressed(false)
    onPressOut?.(event)
  }

  const showIcon = disabled || readOnly

  return (
    <S.Root
      {...props}
      {...defaultProps}
      {...{ isPressed }}
      onPressIn={handlePressIn}
      onPressOut={handlePressOut}
      onLongPress={onLongPress}
    >
      <S.LabelContainer>
        {React.Children.map(children, child => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, defaultProps)
          }
          return child
        })}
      </S.LabelContainer>

      {!showIcon && (
        <Icon size="small" symbol="rdicon-dismiss" color={iconColor} />
      )}
    </S.Root>
  )
}
